import { ADD_ISSUE } from '../../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_ISSUE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_ISSUE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_ISSUE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
